import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { CardDashboard, CardContent } from '@percent/lemonade'
import { getDate } from '@percent/admin-dashboard/common/utility/getDate'
import type { Account } from '@percent/domain/iam'

type SecurityVerificationCardProps = {
  account: Account
  action?: ReactNode
}

export function SecurityVerificationCard({ account, action }: SecurityVerificationCardProps) {
  const { t } = useTranslation()
  const dash = '-'

  return (
    <CardDashboard title={t('memberProfile.securityVerification')} headingLevel="h4" action={action}>
      <CardContent title={t('memberProfile.createdAt')} testId="security-createdAt">
        {getDate(account.createdAt) || dash}
      </CardContent>
      <CardContent title={t('memberProfile.updatedAt')} testId="security-updatedAt">
        {getDate(account.updatedAt) || dash}
      </CardContent>
      <CardContent title={t('memberProfile.verifiedAt')} testId="security-verifiedAt">
        {getDate(account.verifiedAt) || dash}
      </CardContent>
      <CardContent title={t('memberProfile.deletedAt')} testId="security-deletedAt">
        {getDate(account.deletedAt) || dash}
      </CardContent>
      <CardContent title={t('memberProfile.ssoUser')} testId="security-ssoUser">
        {account.ssoUser ? getDate(account.ssoUser) : dash}
      </CardContent>
      <CardContent title={t('memberProfile.twoFaMandatory')} testId="security-twoFaMandatory">
        {account.twoFaMandatory ? t('status.yes') : dash}
      </CardContent>
      <CardContent title={t('memberProfile.twoFaVerifiedAt')} testId="security-twoFaVerifiedAt">
        {getDate(account.twoFaSecretVerifiedAt) || dash}
      </CardContent>
      <CardContent title={t('memberProfile.redactedAt')} testId="security-redactedAt">
        {getDate(account.redactedAt) || dash}
      </CardContent>
    </CardDashboard>
  )
}
